export enum PageId {
    tiles = 'tiles',
    profile = 'profile',
    security = 'security',
    cashbackAndPoints = 'cashbackAndPoints',
    points = 'points',
    services = 'services',
    services_v2 = 'services.v2',
    ucrm = 'ucrm',
    ekyc = 'ekyc',
    address = 'address',
    cards = 'cards',
    address_jp = 'address.jp',
    cancel_membership = 'cancel.membership',
    overview = 'overview',
    linked_accounts = 'linked.accounts',
}
